<app-header></app-header>
<app-progress-bar [planeColor]="'#0045b6'" [passengerColor]="'#0045b6'"></app-progress-bar>
<app-passenger-info></app-passenger-info>
<app-footer></app-footer>